import React from 'react'
import PropTypes from 'prop-types'
import {
  HeaderParagraph,
  Header2,
  StyledContainer,
  StyledLinkWrapper,
  CompletionCircle,
  CompletionCheckmark,
  TagsContainer,
  Tag,
  TagText,
  HeaderTagsContainer,
  MainLayoutContainer,
  ContentWrapper,
} from './component.styles'
import DoneCheckmark from './assets/checkmark-donestate-green.svg'
import { COMPLETED_ALT_TEXT } from './constants'

const TieredInterventionUnitCard = ({
  title,
  description,
  path,
  isPreviewMode = true,
  markedComplete = false,
  tags = [],
}) => {
  return (
    <StyledLinkWrapper to={path}>
      <StyledContainer>
        <MainLayoutContainer>
          {!isPreviewMode && (
            <CompletionCircle
              data-testid="completion-circle"
              markedComplete={markedComplete}
            >
              {markedComplete && (
                <CompletionCheckmark
                  alt={COMPLETED_ALT_TEXT}
                  src={DoneCheckmark}
                />
              )}
            </CompletionCircle>
          )}

          <ContentWrapper>
            <HeaderTagsContainer>
              <Header2>{title}</Header2>
              {tags.length > 0 && (
                <TagsContainer>
                  {tags.map((tag, index) => (
                    <Tag key={index}>
                      <TagText>{tag}</TagText>
                    </Tag>
                  ))}
                </TagsContainer>
              )}
            </HeaderTagsContainer>

            <HeaderParagraph>{description}</HeaderParagraph>
          </ContentWrapper>
        </MainLayoutContainer>
      </StyledContainer>
    </StyledLinkWrapper>
  )
}

TieredInterventionUnitCard.propTypes = {
  description: PropTypes.string,
  isPreviewMode: PropTypes.bool,
  markedComplete: PropTypes.bool,
  path: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
}

export default TieredInterventionUnitCard
